/** Keep contacts unchanged; mask all but the final four digits in a customer copy. */
export function maskCustomerPhone(value: string): string {
  const digits = value.replace(/\D/g, '').length;
  let position = 0;
  return value.replace(/\d/g, (digit) =>
    ++position <= (digits > 4 ? digits - 4 : digits) ? '*' : digit,
  );
}

export function customerPrintHtml(element: HTMLElement, masked: boolean): string {
  const copy = element.cloneNode(true) as HTMLElement;
  if (masked)
    copy.querySelectorAll('[data-customer-phone]').forEach((node) => {
      node.textContent = maskCustomerPhone(node.textContent || '');
    });
  return copy.outerHTML;
}

export function receiptWithPhonePrivacy<T extends { customer?: { phone?: string | null } | null }>(
  receipt: T,
  masked: boolean,
): T {
  if (!masked || !receipt.customer?.phone) return receipt;
  return {
    ...receipt,
    customer: { ...receipt.customer, phone: maskCustomerPhone(receipt.customer.phone) },
  };
}
